module.exports = __webpack_public_path__ + "img/background013.cd6ef3ef.jpg";